<template>
    <div class="inner-page" ref="page">
        <div class="heads">
            <img src="../../assets/ctqyHeadBack.jpg">
            <h1>传统器乐</h1>
        </div>
        <div class="mainBox">
            <a href="http://wap.china1904.com/wx/qySong?iab=ba00f82b81d6714c0181d674f61f065c&icd=ba00f82b81d6714c0181d67647a90815">
                <img src="../../assets/ctqy1.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/qySong?iab=ba00f82b81d6714c0181d67650910826&icd=ba00f82b81d6714c0181d67792ae0a13">
                <img src="../../assets/ctqy2.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/qySong?iab=ba00f82b81d6714c0181d6779f870a24&icd=ba00f82b81d6714c0181d6782a520afd">
                <img src="../../assets/ctqy3.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/qySong?iab=ba00f82b81d6714c0181d67833460b0f&icd=ba00f82b81d6714c0181d67916fc0c94">
                <img src="../../assets/ctqy4.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/qySong?iab=ba00f82b81d6714c0181d6791f230ca3&icd=ba00f82b81d6714c0181d679da630db6">
                <img src="../../assets/ctqy5.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/qySong?iab=ba00f82b81d6714c0181d679eacc0dc8&icd=ba00f82b81d6714c0181d67b38870fd4">
                <img src="../../assets/ctqy6.jpg">
            </a>

        </div>
        <div class="foots">
            <img src="../../assets/ctqyBotBack.jpg">
        </div>
    </div>
</template>

<script>
    export default {
        name: "hsjd"
    }
</script>

<style scoped lang="scss">

    .inner-page{
        background-color: #EDE5D5;
        .heads{
            width: 100%;
            height: 100%;
            position: relative;
            img{
                width: 100%;
            }
            h1{
                position: absolute;
                left: 50%;
                top: 35%;
                transform: translate(-50%,-50%);
                font-size: 24px;
                letter-spacing: 5px;
            }
        }
        .mainBox{
            width: auto;
            height: 100%;
            overflow-y: hidden;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            padding:  20px 10px;
            margin-bottom: 64px;
            a{
                display: block;
                overflow-y: hidden;
                width: 165px;
                padding: 0 6px;

            }
            img{
                width:100%;
                float: left;
                margin-bottom: 20px;
            }
        }
        .foots{
            position: fixed;
            bottom: -3px;
            left: 0;
        }

    }

</style>
